import React, { useContext, useRef } from "react";
import { useState, useEffect } from "react";

import {
  MHeader,
  MTableCell,
  ApiData,
  ActionType,
} from "../Components/table/Table";
import "../Components/table/table.css";

import Header from "../Components/Header/Header";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Checkbox from "@mui/material/Checkbox";
import QuantityInput from "../Components/QuantityInput/QuantityInput";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { Header2 } from "../Components/Header/Header2";
import ModalSupression from "../Components/Modal/ModalSupression";

import { HospitalInterface, VersementInterface } from "../interfaces";
import Pagination from "../Components/pagination/Pagination";
import { rootUrl } from "../constants";
import { CurrentUserContext } from "../App";
import { useReactToPrint } from "react-to-print";
import PrintList from "../Components/printable_list";
export const titles = [
  { label: "Centre", sortable: true },
  { label: "Numéro de quittance", sortable: true },
  { label: "C.Bud", sortable: true },
  { label: "De", sortable: true },
  { label: "À", sortable: true },
  { label: "Montant", sortable: true },
  { label: "Actions", sortable: false },
];

const Versement = () => {
  const componentRef = useRef<HTMLDivElement>(null);
  const [printing, setPrinting] = useState<boolean>(false);

  const [selected, setSelected] = useState<number[]>([]);
  let [currentPage, setCurrentPage] = useState<number>(1);
  const [data, setData] = useState<ApiData<VersementInterface> | null>(null);
  const [searchedText, setSearchedText] = useState<string>("");
  const [typingTimeout, setTypingTimeout] = useState<NodeJS.Timeout>();
  const [quantityTimeouts, setQuantityTimeouts] = useState<
    Map<number, NodeJS.Timeout>
  >(new Map());

  const navigate = useNavigate();
  const [error, setError] = useState(null);

  let currentuserContexxt = useContext(CurrentUserContext);

  let token = useContext(CurrentUserContext).currentUserData!.token;

  const [selectedHospitalIndex, setSelectedHospitalIndex] = useState<number>(0);
  const [isPharmacy, setIsPharmacy] = useState<boolean>(false);

  const [deletingIds, setDeletingIds] = useState<number[]>([]);

  function deleteVersements(id: number[]) {
    const currentSelectedHospitalId =
      currentuserContexxt.currentUserData!.hospitals[selectedHospitalIndex].id;

    const futures = id.map((id) => {
      return axios.delete(
        rootUrl + "/hospital/" + currentSelectedHospitalId + "/payments/" + id,
        {
          headers: {
            Authorization: "Token " + token,
          },
        }
      );
    });
    Promise.all(futures)
      .then((response) => {
        FetchData();
      })
      .catch((error) => {
        setError(error);
      });
  }

  function FetchData() {
    setData(null);
    const currentSelectedHospitalId =
      currentuserContexxt.currentUserData!.hospitals[selectedHospitalIndex].id;
    axios
      .get(rootUrl + "/hospital/" + currentSelectedHospitalId + "/payments", {
        params: {
          page: currentPage,
          search: searchedText,
          for_pharmacy: isPharmacy ? "True" : "False",
        },
        headers: {
          Authorization: "Token " + token,
        },
      })
      .then((response: { data: any }) => {
        console.log(data);
        setData(response.data);
      })
      .catch((error: any) => {
        setError(error);
      });
  }

  useEffect(() => {
    FetchData();
  }, [currentPage, selectedHospitalIndex, isPharmacy]);

  useEffect(() => {
    clearTimeout(typingTimeout);

    // Set a new timeout to delay the search
    const timeoutId = setTimeout(() => {
      setSelected([]);
      currentPage = 1; //should be updated but not render
      FetchData();
    }, 500);

    setTypingTimeout(timeoutId);

    return () => {
      clearTimeout(typingTimeout);
    };
  }, [searchedText]);
  const handlePrint = useReactToPrint({
    onBeforeGetContent() {
      setPrinting(true);
    },

    content: () => {
      return componentRef.current;
    },
    onAfterPrint: () => {
      setPrinting(false);
    },
  });

  return (
    <div className="hopitaux-wrapper">
      {deletingIds.length > 0 && (
        <ModalSupression
          open={false}
          name={`${deletingIds.length} ${deletingIds.length > 1 ? "versements" : "versement"}`}
          onClose={function (): void {
            setDeletingIds([]);
          }}
          onConfirmClick={function (): void {
            deleteVersements(deletingIds);
            setDeletingIds([]);
          }}
        />
      )}

      <Header title={"Liste des versements"} />
      <div className="flex gap-x-2 ml-10 font-pop font-medium">
        {currentuserContexxt.currentUserData?.hospitals.map((h, index) => {
          return (
            <button
              onClick={() => {
                setSelectedHospitalIndex(index);
                setSelected([]);
                setIsPharmacy(false);
                setCurrentPage(1);
              }}
              className={`font-semibold rounded-sm text-black  p-2 transition-all ${
                selectedHospitalIndex === index ? "bg-[#187498] text-white" : ""
              }`}
            >
              <p>{h.name}</p>
            </button>
          );
        })}
      </div>
      {currentuserContexxt.currentUserData?.hospitals[selectedHospitalIndex]
        .has_pharmacy && (
        <div className="flex flex-col gap-y-2 mt-2 ml-10">
          <hr className="w-96 border-slate-400" />

          <div className="flex gap-x-2 font-pop font-medium ">
            <button
              onClick={() => {
                setIsPharmacy(false);
                setCurrentPage(1);
              }}
              className={`font-semibold rounded-sm text-black  p-2 transition-all ${
                !isPharmacy ? "bg-[#187498] text-white" : ""
              }`}
            >
              <p>Hopital</p>
            </button>
            <button
              onClick={() => {
                setIsPharmacy(true);
                setCurrentPage(1);
              }}
              className={`font-semibold rounded-sm text-black  p-2 transition-all ${
                isPharmacy ? "bg-[#187498] text-white" : ""
              }`}
            >
              <p>Pharmacy</p>
            </button>
          </div>
        </div>
      )}
      {
        <Header2
          inputPlaceholder={"Rechercher dans ce tableau"}
          onInputChange={function (text: string): void {
            setSearchedText(text);
          }}
          handlePrint={handlePrint}
        />
      }
      <div className="flex ml-10 mb-4 ">
        <span className="font-semibold">Total : </span>
        <span>
          {data?.data
            .filter(
              (d, index) => selected.length === 0 || selected.includes(d.id)
            )
            .reduce((acc, item) => {
              return acc + item.amount;
            }, 0)}
        </span>
      </div>
      {data === null ? (
        // center loading
        //center
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <CircularProgress thickness={6} sx={{ color: "#0B63F8" }} />
        </div>
      ) : (
        <Table
          style={{
            backgroundColor: "white",
            marginRight: "40px",
            marginLeft: "40px",
            width: "95.5%",
          }}
        >
          <MHeader
            titles={titles}
            withActions={false}
            onCheckClick={() => {
              if (selected.length === data?.data.length) {
                setSelected([]);
              } else {
                setSelected(data?.data.map((item) => item.id) || []);
              }
            }}
            isAllSelected={
              data &&
              data!.data.length !== 0 &&
              selected.length === data?.data.length
            }
          />
          <TableBody>
            {data!.data.map((versement, index) => (
              <TableRow key={index}>
                <TableCell size="small">
                  <Checkbox
                    checked={selected.includes(versement.id)}
                    onChange={() => {
                      if (selected.includes(versement.id)) {
                        setSelected(
                          selected.filter((item) => item !== versement.id)
                        );
                      } else {
                        setSelected([...selected, versement.id]);
                      }
                    }}
                  />
                </TableCell>
                <MTableCell label={versement.hospital_name} isTitle={false} />

                <MTableCell
                  label={`${versement.quittance_number}`}
                  isTitle={false}
                />
                <MTableCell label={`${versement.account}`} isTitle={false} />
                <MTableCell label={`${versement.start_date}`} isTitle={false} />
                <MTableCell label={versement.payed_for} isTitle={false} />
                <MTableCell label={`${versement.amount}`} isTitle={false} />
                <TableCell>
                  <div className="icon-wrapper">
                    <div
                      className="button"
                      onClick={() => {
                        setDeletingIds([versement.id]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                      >
                        <path
                          d="M11.6667 6.125V6.41667H16.3334V6.125C16.3334 5.50616 16.0875 4.91267 15.6499 4.47509C15.2124 4.0375 14.6189 3.79167 14 3.79167C13.3812 3.79167 12.7877 4.0375 12.3501 4.47509C11.9125 4.91267 11.6667 5.50616 11.6667 6.125ZM10.2084 6.41667V6.125C10.2084 5.11939 10.6078 4.15496 11.3189 3.44389C12.03 2.73281 12.9944 2.33334 14 2.33334C15.0056 2.33334 15.9701 2.73281 16.6811 3.44389C17.3922 4.15496 17.7917 5.11939 17.7917 6.125V6.41667H24.3542C24.5476 6.41667 24.733 6.49349 24.8698 6.63024C25.0065 6.76698 25.0834 6.95245 25.0834 7.14584C25.0834 7.33922 25.0065 7.52469 24.8698 7.66144C24.733 7.79818 24.5476 7.875 24.3542 7.875H22.6526L21.4859 21.791C21.3973 22.8478 20.9149 23.8327 20.1343 24.5505C19.3536 25.2684 18.3318 25.6667 17.2714 25.6667H10.7287C9.6683 25.6666 8.64664 25.2681 7.86615 24.5503C7.08567 23.8325 6.60332 22.8477 6.51469 21.791L5.34802 7.875H3.64585C3.45247 7.875 3.267 7.79818 3.13025 7.66144C2.99351 7.52469 2.91669 7.33922 2.91669 7.14584C2.91669 6.95245 2.99351 6.76698 3.13025 6.63024C3.267 6.49349 3.45247 6.41667 3.64585 6.41667H10.2084ZM7.96777 21.6691C8.02584 22.3614 8.34186 23.0066 8.85322 23.4769C9.36457 23.9472 10.0339 24.2083 10.7287 24.2083H17.2714C17.9662 24.2084 18.6357 23.9474 19.1472 23.4771C19.6587 23.0068 19.9748 22.3615 20.0329 21.6691L21.189 7.875H6.81102L7.96777 21.6691ZM12.5417 11.8125C12.5417 11.7167 12.5228 11.6219 12.4862 11.5335C12.4495 11.445 12.3958 11.3646 12.3281 11.2969C12.2604 11.2292 12.18 11.1755 12.0916 11.1388C12.0031 11.1022 11.9083 11.0833 11.8125 11.0833C11.7168 11.0833 11.6219 11.1022 11.5335 11.1388C11.445 11.1755 11.3646 11.2292 11.2969 11.2969C11.2292 11.3646 11.1755 11.445 11.1389 11.5335C11.1022 11.6219 11.0834 11.7167 11.0834 11.8125V20.2708C11.0834 20.3666 11.1022 20.4614 11.1389 20.5499C11.1755 20.6383 11.2292 20.7187 11.2969 20.7864C11.3646 20.8541 11.445 20.9079 11.5335 20.9445C11.6219 20.9811 11.7168 21 11.8125 21C11.9083 21 12.0031 20.9811 12.0916 20.9445C12.18 20.9079 12.2604 20.8541 12.3281 20.7864C12.3958 20.7187 12.4495 20.6383 12.4862 20.5499C12.5228 20.4614 12.5417 20.3666 12.5417 20.2708V11.8125ZM16.1875 11.0833C16.59 11.0833 16.9167 11.41 16.9167 11.8125V20.2708C16.9167 20.4642 16.8399 20.6497 16.7031 20.7864C16.5664 20.9232 16.3809 21 16.1875 21C15.9941 21 15.8087 20.9232 15.6719 20.7864C15.5352 20.6497 15.4584 20.4642 15.4584 20.2708V11.8125C15.4584 11.41 15.785 11.0833 16.1875 11.0833Z"
                          fill="#EB5353"
                        />
                      </svg>
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
      {data && (
        <Pagination
          currentPage={currentPage}
          totalPages={data!.total_pages}
          onPageChange={function (page: number): void {
            setCurrentPage(page);
          }}
        />
      )}
      <div ref={componentRef}>
        <PrintList
          centerName={
            currentuserContexxt.currentUserData!.hospitals[
              selectedHospitalIndex
            ].name
          }
          title={"Liste des versements"}
          titles={titles.map((title) => title.label)}
          showRegisseur={true}
          afterTable={
            <div className="flex">
              <span className="font-semibold">Total : </span>
              <span>
                {data?.data
                  .filter(
                    (d, index) =>
                      selected.length === 0 || selected.includes(d.id)
                  )
                  .reduce((acc, item) => {
                    return acc + item.amount;
                  }, 0)}
              </span>
            </div>
          }
          data={
            data?.data
              .filter(
                (versement) =>
                  selected.length === 0 || selected.includes(versement.id)
              )
              .map((versement) => [
                versement.hospital_name,
                versement.quittance_number,
                versement.account,
                versement.start_date,
                versement.payed_for,
                versement.amount,
              ]) ?? []
          }
        />
      </div>
    </div>
  );
};

export default Versement;

function CheckRefuseActions({
  onClick,
}: {
  onClick: (value: boolean) => void;
}) {
  return (
    <TableCell>
      <div className="flex flex-row gap-x-5">
        <svg
          onClick={() => {
            onClick(true);
          }}
          className="w-7 h-7 hover:scale-110 transition-all cursor-pointer items-center"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <path
              d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z"
              stroke="#3a9933"
              stroke-width="1.5"
            ></path>{" "}
            <path
              d="M8.5 12.5L10.5 14.5L15.5 9.5"
              stroke="#3a9933"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>{" "}
          </g>
        </svg>
        <svg
          onClick={() => {
            onClick(false);
          }}
          className="w-7 h-7 hover:scale-110 transition-all cursor-pointer items-center"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <path
              d="M12.9998 8L6 14L12.9998 21"
              stroke="#f25f5f"
              stroke-width="4"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>{" "}
            <path
              d="M6 14H28.9938C35.8768 14 41.7221 19.6204 41.9904 26.5C42.2739 33.7696 36.2671 40 28.9938 40H11.9984"
              stroke="#f25f5f"
              stroke-width="4"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>{" "}
          </g>
        </svg>
      </div>
    </TableCell>
  );
}
